import { TransactionType } from "src/models/Transactions.model";
export const transactionTypeOptions: {
  label: string;
  value: keyof typeof TransactionType;
}[] = [
  {
    label: "Fees",
    value: "FEES_COLLECTION",
  },
];
